import React from "react";

/**
 * ErrorBoundary — isole les crashs React par route/module.
 *
 * Usage :
 *   <ErrorBoundary>
 *     <MaPage />
 *   </ErrorBoundary>
 *
 * Chaque instance est indépendante : une page qui crash n'affecte pas les autres.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.reset = this.reset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log structuré pour Render / Vercel — visible dans les logs serveur
    console.error("[ErrorBoundary] Crash capturé :", error?.message, {
      componentStack: info?.componentStack?.slice(0, 500),
      route: window.location.pathname,
    });
  }

  reset() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const { label = "cette page" } = this.props;

    return (
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", minHeight: "60vh",
        padding: "32px 16px", fontFamily: "'DM Sans', system-ui, sans-serif",
        textAlign: "center",
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: "50%",
          background: "rgba(220,38,38,0.1)", display: "flex",
          alignItems: "center", justifyContent: "center", marginBottom: 20,
        }}>
          <span style={{ fontSize: 24 }}>⚠</span>
        </div>
        <h2 style={{ color: "#DC2626", fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
          Erreur sur {label}
        </h2>
        <p style={{ color: "#6b7280", fontSize: 13, marginBottom: 24, maxWidth: 360 }}>
          {this.state.error?.message || "Une erreur inattendue s'est produite."}
        </p>
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={this.reset}
            style={{
              padding: "10px 20px", background: "#3A7D44", color: "white",
              border: "none", borderRadius: 10, fontSize: 14,
              fontWeight: 600, cursor: "pointer",
            }}
          >
            Réessayer
          </button>
          <button
            onClick={() => { window.location.href = "/dashboard"; }}
            style={{
              padding: "10px 20px", background: "#f3f4f6", color: "#374151",
              border: "none", borderRadius: 10, fontSize: 14,
              fontWeight: 600, cursor: "pointer",
            }}
          >
            Retour au dashboard
          </button>
        </div>
      </div>
    );
  }
}
